import React from 'react';
import { Badge, Flex, Icon, IconButton, Text } from '@chakra-ui/react';
import { DownloadIcon, PrinterIcon } from 'ts/common/components/icons';

interface Props {
    headingText: string;
    statusText: string;
    actionButtons?: {
        onClickPrint: () => void;
        onClickDownload: () => void;
        printLabel: string;
        downloadLabel: string;
    };
}

const ClientPageCardHeader = ({ headingText, statusText, actionButtons }: Props) => {
    return (
        <Flex justifyContent="space-between" alignItems="flex-start" mb={3}>
            <Flex flexDirection="column" alignItems="flex-start" gap="8px">
                <Text as="h2" fontSize="20px" fontWeight="600">
                    {headingText}
                </Text>
                <Badge variant="outline">{statusText}</Badge>
            </Flex>
            {actionButtons && (
                <Flex gap={4} alignItems="center">
                    <IconButton
                        icon={<Icon as={PrinterIcon} boxSize="24px" />}
                        variant="ghost"
                        size="24px"
                        aria-label={actionButtons.printLabel}
                        onClick={actionButtons.onClickPrint}
                        cursor="pointer"
                    />
                    <IconButton
                        icon={<Icon as={DownloadIcon} boxSize="24px" />}
                        variant="ghost"
                        size="24px"
                        aria-label={actionButtons.downloadLabel}
                        onClick={actionButtons.onClickDownload}
                        cursor="pointer"
                    />
                </Flex>
            )}
        </Flex>
    );
};

export default ClientPageCardHeader;
